import { useEffect, useRef, useState } from "react";
import { slideDown, slideUp } from '../animation/animation';

const ThemeEight = ({ attributes, setAttributes }) => {

    const { faqData = [], faqIcon = {} } = attributes || {};
    const { open, close } = faqIcon;

    const [openIndex, setOpenIndex] = useState(null);

    const refs = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
        setAttributes({ activeItem: index });
    };

    useEffect(() => {
        refs.current.forEach((el, i) => {
            if (!el) return;

            if (openIndex === i) {
                slideDown(el, 700);
            } else {
                slideUp(el, 700);
            }
        });
    }, [openIndex]);

    return (
        <div className='themeEightWrapper faq-container-style'>
            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div key={index} className="faq-item themeFourSection">
                        <div
                            className={`faq-question ${openIndex === index ? "active" : ""}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-icon">
                                {openIndex === index ? <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: open }}
                                /> : <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: close }}
                                />}
                            </div>
                            <div className="faq-question-title">
                                {item?.question}
                            </div>
                        </div>

                        <div
                            className={`content  ${openIndex === index ? "show faq-answer" : ""}`}
                            ref={(el) => (refs.current[index] = el)}
                            style={{ overflow: "hidden", height: 0 }}
                        >

                            <div className="faq-content">
                                <img src={item.image} alt="FAQ visual" />
                                <div>
                                    <p className="faq-answer-para">{item?.answer}</p>
                                </div>
                            </div>


                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ThemeEight;